import type { UsageProfileBucket } from "../../diagnosticData";
import type { T } from "./i18nTypes";

/** Nome de cada balde do perfil de uso. Texto fixo por `case` e não mapa
 * indexado: o guarda de i18n não enxerga chamada de tradução com variável, e
 * os quatro sairiam crus numa tela em português. É o mesmo nome no card do Ato 1
 * e na lista de usuários ativos (#1478). */
export function usageProfileLabel(bucket: UsageProfileBucket, t: T): string {
  switch (bucket) {
    case "operational":
      return t("Operational");
    case "managerial":
      return t("Managerial");
    case "self_service":
      return t("Self-service");
    case "technical":
      return t("Technical");
  }
}
